import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { GeneralResponse, Token } from "../../../types/api";
import { IProfileChangePhoneNumberResendCodeRequest } from "../../../types/apis/profile";

export const ProfileChangePhoneNumberResendOTPCode = async (
  payload: IProfileChangePhoneNumberResendCodeRequest,
  token: Token
): Promise<GeneralResponse> => {
  try {
    const response = await Api<
      any,
      GeneralResponse<IProfileChangePhoneNumberResendCodeRequest>
    >({
      method: Methods.POST,
      endpoint: EndPoints.ChangePhoneNumberResendCode,
      body: payload,
      token
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useProfileChangePhoneNumberResendOTPCode = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    { payload: IProfileChangePhoneNumberResendCodeRequest; token: Token }
  > = useMutation({
    mutationFn: ({ payload, token }) => ProfileChangePhoneNumberResendOTPCode(payload, token),
    ...options,
  });

  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
